var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberInputWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 50,
    rx: 5,
    fill: "#2a2a2a",
    stroke: "#444"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 15,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 30,
    textAnchor: "middle",
    fill: "#eee",
    fontFamily: "monospace",
    fontSize: 12
  }, "20"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 30,
    textAnchor: "middle",
    fill: "#eee",
    fontFamily: "monospace",
    fontSize: 16
  }, "\xB1"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberInputWidget);
export default __webpack_public_path__ + "static/media/number-input-widget.a339fb437ccb1047aa87e56bd0d0ac56.svg";
export { ForwardRef as ReactComponent };